import React, { useState } from 'react'
import TextInput from '../../common/TextInput'
import { useTranslation } from '../../../lib/i18n'

const AltTextInput = ({ register, showText = false }) => {
  const { t } = useTranslation()
  const [showAltTextInput, setShowAltTextInput] = useState(showText)

  if (!showAltTextInput) {
    return (
      <div>
        <span
          onClick={() => setShowAltTextInput(true)}
          onKeyDown={() => setShowAltTextInput(true)}
          role="button"
          tabIndex="0"
          className="text-base text-blue-500 font-bold"
        >
          {t('common.addAltText')}
        </span>
        <p className="text-sm text-subtitle">
          {t('common.altTextDescription')}
        </p>
      </div>
    )
  }

  return (
    <TextInput
      name="altText"
      label={t('common.addAltTextLabel')}
      register={register}
    />
  )
}

export default AltTextInput
